import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';

export const externalRegistrationLinkNk: string = 'SIS_REGISTRATION_URL';
export interface IExternalRegistrationLinkModel {
  nk: string;
  text?: string;
}

export type ExternalRegistrationLinkModel = ITypedModel<IExternalRegistrationLinkModel>;

angular.module('capability-ng-academic-planner').factory(
  'ngExternalRegistrationLinkModel',
  () =>
    new Model<IExternalRegistrationLinkModel>({
      nk: externalRegistrationLinkNk,
      text: undefined
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/advisor_header/components/external_registration_link/models/external_registration_link_model.ts